import { CommonModule } from '@angular/common';

import { APP_INITIALIZER, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { firstValueFrom, interval, switchMap } from 'rxjs';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AuthService } from './services/auth/auth.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ToastModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => {
        return () => firstValueFrom(authService.checkAuth());
      },
      deps: [AuthService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'frontend-istid';

  constructor(
    private primengConfig: PrimeNGConfig,
    private readonly authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.checkAuth().subscribe();
    this.primengConfig.ripple = true;
    this.primengConfig.zIndex = {
      modal: 10,    // dialog, sidebar
      overlay: 9,  // dropdown, overlay-panel
      menu: 9,     // overlay menus
      tooltip: 10,   // tooltip
      toolbar: 7,  // toolbar
    };

    // @ ToDo: rozważyć usunięcie, pobranie z API wydłuża token.
    interval(12 * 60 * 1000) // co 12 min
      .pipe(switchMap(() => this.authService.refresh()))
      .subscribe({ error: () => {} });
  }
}
